import { useEffect, useRef, useState } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Renderiza o botão oficial do Google Identity Services em um container ref.
// onCredential(idToken) é disparado quando o usuário autentica.
export default function useGoogleIdentity({ containerRef, onCredential, text = 'signin_with' }) {
  const [ready, setReady] = useState(false);
  const initedRef = useRef(false);

  useEffect(() => {
    if (!CLIENT_ID) return;
    if (initedRef.current) return;

    const tryInit = () => {
      if (!window.google?.accounts?.id || !containerRef.current) return false;
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: (resp) => {
          if (resp?.credential) onCredential(resp.credential);
        },
        auto_select: false,
        cancel_on_tap_outside: true,
      });
      window.google.accounts.id.renderButton(containerRef.current, {
        theme: 'filled_blue',
        size: 'large',
        text,
        shape: 'pill',
        width: containerRef.current.offsetWidth || 320,
      });
      initedRef.current = true;
      setReady(true);
      return true;
    };

    if (tryInit()) return;
    const t = setInterval(() => { if (tryInit()) clearInterval(t); }, 250);
    return () => clearInterval(t);
  }, [containerRef, onCredential, text]);

  return { ready, hasClientId: !!CLIENT_ID };
}
